import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TradeOrderReversalService } from '../../services/wealthlane-award-settlement-services/services/TradeOrderReversalService';
import { Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto } from '../../services/wealthlane-award-settlement-services/models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto';


const usePostReverseTradeOrder = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    onSuccess?: () => void,
    closeModal?: () => void
): UseMutationResult<
    any,
    unknown,
    string,
    unknown
> => {
    const queryClient = useQueryClient();

    return useMutation(
        async (tradeOrderId: string) => {
            const payload: Wealthlane_AwardSettlementService_Dtos_TradeOrder_ReverseTradeOrderByIdDto = {
                tradeOrderIds: [tradeOrderId],
            };
            return await handleRequest(
                TradeOrderReversalService.postApiAwardSettlementApiAppTradeOrderReversalReverseOrderById(
                    payload
                )
            );
        },
        {
            onSuccess: async (response: any) => {
                closeModal && closeModal();
                if (response !== null && response?.isSuccess) {
                    toast.success(
                        <ToastComponent label='Success' message={`${String(response?.message ?? 'Trade order reversed successfully.')}`} />
                    );
                    onSuccess && onSuccess();
                    await queryClient.invalidateQueries('getTransactionsReleaseDetailList');
                    await queryClient.invalidateQueries('getOptionExercisedList');
                } else {
                    closeModal && closeModal();
                    throw {
                        message: response?.message,
                        errors: response?.errors,
                        error: new Error(),
                    };
                }
            }
            ,
            onError: (err: any) => {
                closeModal && closeModal();
                console.log('error', err);

            },
        }
    );
};

export default usePostReverseTradeOrder;
